<template>
  <div class="device-marker-popup">
    <div class="device-marker-header">{{this.header}}</div>
    <div class="device-marker-body">
      <div class="device-marker-content">{{this.content}}</div>
      <div class="device-marker-alert">{{this.alert}}</div>
      <a class="device-marker-details" @click="goToGraph()">View Details</a>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'MarkerPopup',
  props: {
    header: String,
    content: String,
    alert: String,
    devicetype: String,
    $router: Object // Pass router as prop for HTML Element rendered component
  },
  methods: {
    /**
     * Push graph view for the marker device.
     */
    goToGraph () {
      const date = {
        datefrom: moment().subtract(30, 'days')
          .format('YYYYMMDD000000'),
        dateto: moment().format('YYYYMMDD235959')
      }
      this.$router.push({
        name: 'DeviceTypeGraph',
        params: {
          deviceID: this.header,
          displayname: this.content,
          devicetype: this.devicetype
        },
        query: { datefrom: date.datefrom, dateto: date.dateto }
      })
    }
  }
}
</script>

<style scoped>
.device-marker-header {
    font-size: 1.5em;
    font-weight: bold;
}

.device-marker-alert {
    padding-left: 0.2em;
    margin: 0.5em 0;
    border-left: #c7cfc3 0.3em solid;
}
</style>
